import type { PagePermissions } from "./permissionsTypes.ts";

export type PermissionModuleUsage = {
  moduleName: string;
  permissions: PagePermissions;
};

const modulesByPath = new Map<string, Map<string, PermissionModuleUsage>>();

const normalizePath = (path: string) => path.split("?")[0].split("#")[0] || "/";

export const registerPermissionModuleUsage = (
  moduleName: string,
  permissions: PagePermissions,
  path?: string,
) => {
  if (typeof window === "undefined") {
    return;
  }

  const resolvedPath = path ?? window.location.pathname;
  const normalizedPath = normalizePath(resolvedPath);
  const pathModules = modulesByPath.get(normalizedPath) ?? new Map();

  pathModules.set(moduleName, {
    moduleName,
    permissions,
  });

  modulesByPath.set(normalizedPath, pathModules);
};

export const getPermissionModuleUsageForPath = (path: string) => {
  const normalizedPath = normalizePath(path);
  const pathModules = modulesByPath.get(normalizedPath);

  if (!pathModules) {
    return [] as PermissionModuleUsage[];
  }

  return [...pathModules.values()].sort((a, b) =>
    a.moduleName.localeCompare(b.moduleName),
  );
};
